import { z } from "zod";

/**
 * Building blocks shared by the activity timelines read off `audit_change_log`
 * (workflows, task types): who acted, one field's diff, and offset paging.
 */

export const ActivityActorSchema = z.object({
  userId: z.uuid().nullable(),
  userName: z.string().nullable(),
  sourceType: z.enum(["api", "workflow", "system"]).nullable(),
  sourceDetail: z.string().nullable(),
});

export const ActivityFieldDiffSchema = z.object({
  old: z.unknown(),
  new: z.unknown(),
});

/** Offset paging fields for a timeline request. */
export const activityPageInputShape = {
  limit: z.number().int().min(1).max(200).optional().default(50),
  offset: z.number().int().min(0).optional().default(0),
};

/** A page of timeline entries, newest first. */
export function activityPageResponseSchema<Entry extends z.ZodType>(
  entry: Entry,
) {
  return z.object({
    entries: z.array(entry),
    total: z.number().int(),
    hasMore: z.boolean(),
  });
}

export type ActivityActor = z.infer<typeof ActivityActorSchema>;
export type ActivityFieldDiff = z.infer<typeof ActivityFieldDiffSchema>;
